import { ApiPromise, useApi } from '@/api/useApi.ts';
import { ITableDataConfig } from '@/interfaces/powerMarkets/table/ITableDataConfig.ts';

const apiCall = useApi();
const entsoeApiCall = useApi('entsoe');
const franceApi = useApi('france');
const epexApi = useApi('epex');
const staticApi = useApi('static');

function getChartAggregateSlideOut (seriesId: string, countryId: string): ApiPromise<ITableDataConfig> {
    switch (countryId) {
        case 'gb':
            return apiCall.post<{id: string}, ITableDataConfig>({
                endpoint: '/chartAggregateSlideOut/config',
                payload: { id: seriesId },
            });
        case 'france':
            return franceApi.post<{id: string}, ITableDataConfig>({
                endpoint: '/chartAggregateSlideOut/config',
                payload: { id: seriesId },
            });
        case 'epex':
            return epexApi.post<{id: string}, ITableDataConfig>({
                endpoint: '/chartAggregateSlideOut/config',
                payload: { id: seriesId },
            });
        case 'static':
            return staticApi.post<{id: string}, ITableDataConfig>({
                endpoint: '/chartAggregateSlideOut/config',
                payload: { id: seriesId },
            });
        default:
            return entsoeApiCall.post<{id: string}, ITableDataConfig>({
                endpoint: '/chartAggregateSlideOut/config',
                payload: { id: seriesId },
            });
    }
}

export const drilldownApi = {
    getChartAggregateSlideOut,
};
